import React, { useEffect, useState } from 'react';
import { Utility } from '@nkr/services/utility';
import { IDetailData } from '../detail-data';
import { Col, ControlLabel, FormControl, Glyphicon, HelpBlock, Panel } from 'react-bootstrap';
import { PanelBodyWrapper, FormField } from '../styles';
import { Controller, useFormContext } from 'react-hook-form';
import MaskedInput from 'react-maskedinput';

interface IProps {
    disableEdit: boolean
}

const ContactInformation = ({ disableEdit }: IProps) => {
    const { control, formState: { errors } } = useFormContext<IDetailData>();
    const [open, setOpen] = useState(true);

    return (
        <Panel expanded={open}>
            <Panel.Heading style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Panel.Title style={{ fontSize: 14, cursor: 'default' }} onClick={() => setOpen(!open)}>Contact Information</Panel.Title>
                <Panel.Toggle onClick={() => setOpen(!open)}><Glyphicon glyph={open ? 'triangle-bottom' : 'triangle-top'} /></Panel.Toggle>
            </Panel.Heading>
            <Panel.Collapse>
                <PanelBodyWrapper>
                    <FormField validationState={errors.email != null ? 'error' : null}>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Email: *</Col>
                        <Col xs={12} lg={8}>
                            <Controller
                                control={control}
                                name='email'
                                rules={{
                                    validate: (value) => {
                                        if (!value?.trim()) {
                                            return 'Email is required';
                                        }

                                        if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                                            return 'Invalid email format';
                                        }

                                        return true;
                                    }
                                }}
                                render={({ field: { onChange, value, ref } }) => (
                                    <FormControl
                                        type='text'
                                        disabled={disableEdit}
                                        value={value}
                                        onChange={onChange}
                                    />
                                )} />

                            {errors.email != null &&
                                <HelpBlock>{errors.email.message}</HelpBlock>
                            }
                        </Col>
                    </FormField>

                    <FormField validationState={errors.phoneNumber != null ? 'error' : null}>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Mobile Phone #:</Col>
                        <Col xs={12} lg={8}>
                            <Controller
                                control={control}
                                name='phoneNumber'
                                rules={{
                                    validate: (value) => {
                                        let pv = Utility.validatePhoneNumber(value, 'Mobile Phone #');

                                        if (pv.isValid == false) {
                                            return pv.errorMessage;
                                        }

                                        return true;
                                    }
                                }}
                                render={({ field: { onChange, value, ref } }) => (
                                    <MaskedInput
                                        mask='(111) 111-1111'
                                        placeholder='(123) 456-7890'
                                        className={`form-control ${errors.phoneNumber != null ? 'has-error' : ''}`}
                                        disabled={disableEdit}
                                        value={value || ''}
                                        onChange={onChange}
                                    />
                                )} />

                            {errors.phoneNumber != null &&
                                <HelpBlock>{errors.phoneNumber.message}</HelpBlock>
                            }
                        </Col>
                    </FormField>

                    <FormField validationState={errors.phoneNumberSecondary != null ? 'error' : null}>
                        <Col xs={12} lg={4} componentClass={ControlLabel}>Alternate Phone #:</Col>
                        <Col xs={12} lg={8}>
                            <Controller
                                control={control}
                                name='phoneNumberSecondary'
                                rules={{
                                    validate: (value) => {
                                        let pv = Utility.validatePhoneNumber(value, 'Alternate Phone #');

                                        if (pv.isValid == false) {
                                            return pv.errorMessage;
                                        }

                                        return true;
                                    }
                                }}
                                render={({ field: { onChange, value, ref } }) => (
                                    <MaskedInput
                                        mask='(111) 111-1111'
                                        placeholder='(123) 456-7890'
                                        className={`form-control ${errors.phoneNumberSecondary != null ? 'has-error' : ''}`}
                                        disabled={disableEdit}
                                        value={value || ''}
                                        onChange={onChange}
                                    />
                                )} />

                            {errors.phoneNumberSecondary != null &&
                                <HelpBlock>{errors.phoneNumberSecondary.message}</HelpBlock>
                            }
                        </Col>
                    </FormField>
                </PanelBodyWrapper>
            </Panel.Collapse>
        </Panel>
    );
}

export default ContactInformation;